import React, {Component} from 'react';
import BackLink from '../../../common/back-link/index';
import PageTitle from "../../../common/page-title/index";
import {Grid, Row, Col, ControlLabel, FormGroup, Radio} from 'react-bootstrap'
import ImageUpload from '../../../common/form/elements/image-upload';
import RequiredInput from '../../../common/form/elements/required-input';
import {Form, Control, Errors, actions} from 'react-redux-form';
import ArrowButton from '../../../common/button-arrow';
import {getTile, updateTiles} from '../../../../actions/home'
import {connect} from 'react-redux';

class DynamicEditTile extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getTile(this.props.match.params.id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.tile'));

  }

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.tile', updateTiles(payLoad, this.props.match.params.id, this.props.tile.data.attributes.kind)));
  };

  render() {
    let image = this.props.tile
      ? this.props.tile.data.attributes.links.image
      : undefined;

    let default_img = this.props.tile
      ? this.props.tile.data.attributes.links["default-image"]
      : undefined;

    return (
      <Grid bsClass="container" fluid className="homepage">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/homepage#tiles"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Dynamic edit tile</PageTitle>
          </Col>
        </Row>
        <Col md={12}>
          {
            this.props.tile &&
            <Row>
              <Form model="deep.tile" onSubmit={this.onSubmit}>

                <Errors className="errors" model="deep.tile"/>

                <Row>
                  <Col lg={12}>
                    <ImageUpload
                      required
                      label="Default Image"
                      source={default_img}
                      sizeLimit={1024 * 1024}
                      model='.default_image'
                      type={['image/png', 'image/jpg', 'image/jpeg']}/>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <RequiredInput
                      label="Button label"
                      disabled={true}
                      placeholder="Button label"
                      model="deep.tile.label"
                      controlId="label"/>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <RequiredInput
                      label="Button link"
                      disabled={true}
                      placeholder="Button link"
                      model="deep.tile.link"
                      controlId="link"/>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <ImageUpload
                      required
                      source={image}
                      sizeLimit={1024 * 1024}
                      model='.image'
                      type={['image/png', 'image/jpg', 'image/jpeg']}/>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup controlId="buttonColor">
                      <div>
                        <ControlLabel>Button colour*</ControlLabel>
                      </div>
                      <Control.radio inline model=".button_color" value="Red" component={Radio}>Red</Control.radio>
                      <Control.radio inline model=".button_color" value="Yellow"
                                     component={Radio}>Yellow</Control.radio>
                      <Control.radio inline model=".button_color" value="White" component={Radio}>White</Control.radio>
                      <Control.radio inline model=".button_color" value="Grey" component={Radio}>Grey</Control.radio>
                    </FormGroup>
                  </Col>
                </Row>
                <Col md={12}>
                  <Row>
                    <ArrowButton className="float-right"
                                 color="red"
                                 disabled={!this.props.formValid}>save</ArrowButton>
                  </Row>
                </Col>
              </Form>
            </Row>
          }
        </Col>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tile:      state.home.home_tile,
    formValid: state.deep.forms.tile.$form.valid
  };
};

export default connect(mapStateToProps)(DynamicEditTile);


// WEBPACK FOOTER //
// ./src/components/admin/homepage-tiles/dynamic-edit-tile/index.jsx